import { MODULE_DEFAULT, MODULE_GLOBAL } from '../support/constant';

export default {
  _lifecycle: {
    [MODULE_DEFAULT]: {},
    [MODULE_GLOBAL]: {},
  },
  _mountedOnce: {

  },
  _willUnmountOnce: {

  }
}
